import "amfe-flexible"
import "./common/font/font.css"
import "./common/font/Alternate.css"
// import "vant/lib/index.css"
import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import Log from "@xyy-saas/log"

import { getuserId, getSign } from "./utils/auth.js"

import {
  Button,
  NavBar,
  Progress,
  Tab,
  Tabs,
  Collapse,
  CollapseItem,
  Toast,
  Icon,
  Loading,
  Dialog,
  Field,
  Popup,
  DatetimePicker,
  Picker,
  Circle,
  Overlay 
} from 'vant'
// import Vconsole from "vconsole"
// let vConsole = new Vconsole()
// export default vConsole
Vue.use(Button)
  .use(NavBar)
  .use(Progress)
  .use(Tab)
  .use(Tabs)
  .use(Collapse)
  .use(CollapseItem)
  .use(Toast)
  .use(Icon)
  .use(Loading)
  .use(Dialog)
  .use(Field)
  .use(Popup)
  .use(DatetimePicker)
  .use(Picker)
  .use(Circle)
  .use(Overlay)

Vue.config.productionTip = false

// console.log("用户id", getuserId(), getSign())
try {
  webSdk.identify(getuserId(), {
    orgSign: getSign()
  })
  Log.init()
} catch (error) {}
window.Log = Log

new Vue({
  router,
  render: h => h(App)
}).$mount("#app")
